const editorDictionary = {
  editorBlock: {
    editorBlockBoundary: {
      newParagraph: "New paragraph"
    }
  }
};
export {
  editorDictionary
};
//# sourceMappingURL=editorDictionary.js.map
